import React from "react";
import { css, useTheme } from "@emotion/react";

import NavLinkTag from "core/Components/Navigations/NavLinkTag";

type Props = {
    subMenu: StandardPage,
};

const FooterVerticalSubMenu: React.FC<Props> = ({
    subMenu,
}) => {
    const theme = useTheme();

    const style = css`
        margin-top: 29px;
        color: ${theme.colours.doveGray};
        
        &:last-of-type {
            margin-bottom: 19px;
        }
        
        &:hover {
            opacity: 0.7;
        }
    `;

    return (
        <div css={style}>
            <NavLinkTag css={style} data={subMenu}>
                {subMenu.titleForFooter ?? subMenu.title}
            </NavLinkTag>
        </div>
    );
};

export default FooterVerticalSubMenu;